import { render } from "./NewsProject.vue?vue&type=template&id=e73cebd0&ts=true"
import script from "./NewsProject.vue?vue&type=script&lang=ts"
export * from "./NewsProject.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__